import { useEffect } from "react";

interface KeyboardShortcutHandlers {
  onSave?: () => void;       // Cmd/Ctrl+S — preventDefault always called
  onGenerate?: () => void;   // Cmd/Ctrl+G — only fires when !isGenerating
  onEscape?: () => void;     // Escape
  isGenerating?: boolean;    // guards onGenerate
}

export function useKeyboardShortcuts({
  onSave,
  onGenerate,
  onEscape,
  isGenerating = false,
}: KeyboardShortcutHandlers): void {
  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      const mod = e.metaKey || e.ctrlKey;

      if (mod && e.key === "s") {
        e.preventDefault();
        onSave?.();
        return;
      }

      if (mod && e.key === "g") {
        e.preventDefault();
        if (!isGenerating) {
          onGenerate?.();
        }
        return;
      }

      if (e.key === "Escape") {
        onEscape?.();
        return;
      }
    }

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onSave, onGenerate, onEscape, isGenerating]);
}
